// extracted by mini-css-extract-plugin
export default {"fullscreenPreview":"LargeImage_fullscreenPreview__l-xFO","image":"LargeImage_image__Bx92D"};